import React, { useState, useContext, useEffect, useMemo } from "react";
import { Dropdown, Button, Col, Row } from "react-bootstrap";
import {
  Typography,
  Paper,
  styled,
  TableHead,
  Table,
  TableBody,
  Backdrop,
  CircularProgress,
  TableContainer,
  TableRow,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { Context } from "../../../context/DataProvider";
import "../../utils/css/rightDiv.css";
import "../../utils/css/leftDiv.css";
import Carousel from "../../customFiles/Carousel";
import { HIDE_BENEFITS_SECTIONS_ENTITY_ID_LIST, OPDConfig, ScreenName, WIPRO_ENTITY_ID_LIST, NESTLE_ENTITY_ID_LIST, ADOBE_ENTITY_ID_LIST } from "../../../config/constants";
import { trackEvent, USER_DETAILS_KEY } from "../../../config/eventHandlers.js";
import { prepareUserDetails } from "../../../config/analytics.js";
import {
  getFormName,
  LocalStorageKeys,
  pageConfigurationCarouselIDs,
  pageConfigurationPageIDs,
  KEY_NOTES_POPUP_NESTLE,
  KEY_NOTES_POPUP_ADOBE,
} from "../../utils/constants/constants.js";
import { getUserDetails, handleBannerClick, isMobile, getMasFiscalYear } from "../../utils/miscutils.js";
import {
  getCustomerSupportEmailId,
  RELOGIN_URL,
} from "../../../utils/constants.js";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Tooltip } from "@mui/material";
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import MobileSecurityFooter from '../../customFiles/MobileSecurityFooter';
import NestleKeyNotesInstructions from '../../customFiles/NestleKeyNotesInstructions';
import AdobeKeyNotesInstructions from '../../customFiles/AdobeKeyNotesInstructions';
import { getRedirectToken } from "../../../utils/cookieUtils";
import axiosInstance from "../../../utils/axiosInterceptor.js";
import { isWebView } from "../../utils/deviceUtils.js";
import { PM_ENTITY_ID } from "../../utils/constants/constants.js";
import useTaskDeviceBridge from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";


export default function Rightdiv(props) {
  const { flag, tabSwitching, setTabSwitching } = useContext(Context);
  const navigate = useNavigate();
  const [claim, setClaim] = useState();
  const [userDetails, setUserDetails] = useState(); 
  const [ledger, setLedger] = useState();
  const [loading, setLoading] = useState(true);
  // should be a dictionary for showing action but currently implementing with another state
  const [message, setMessage] = useState();
  const [showLoginAction, setShowLoginAction] = useState(false);
  const [summary, setSummary] = useState();
  const [isundermaintenance, setisundermaintenance] = useState(0);
  const [entityidCheck, setEntityIdCheck] = useState(false);
  const [createClaimDisable, setCreateClaimDisable] = useState(false);
  const [reimbursementLimits, setReimbursementLimits] = useState([]);
  const [userPolicies, setUserPolicies] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState();
  const [showMasPolicy, setShowMasPolicy] = useState(true);
  const [showMasPolicyPopup, setShowMasPolicyPopup] = useState(false);
  const [masPolicyCollapsed, setMasPolicyCollapsed] = useState(false);
  const [showNestleKeyNotesPopup, setShowNestleKeyNotesPopup] = useState(false);
  const [nestleKeyNotesCollapsed, setNestleKeyNotesCollapsed] = useState(false);
  const [showAdobeKeyNotesPopup, setShowAdobeKeyNotesPopup] = useState(false);
  const [adobeKeyNotesCollapsed, setAdobeKeyNotesCollapsed] = useState(false);
  const [dateSort, setDateSort] = useState(null);
  const [sortLoading, setSortLoading] = useState(false);
  const [masViewMore, setMasViewMore] = useState(false);
  const ledgerBg = ["#FAFBFF", "#ffffff"];
  let apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL;
  const { setUserName, setUserPoliciesCtx, setSelectedPolicyIdCtx, selectedPolicyIdCtx } = useContext(Context);
  const [selectedPolicyId, setSelectedPolicyId] = useState(
  selectedPolicyIdCtx || localStorage.getItem("entityPolicyId")
);
 const taskDeviceBridge = useTaskDeviceBridge();
  const token = getRedirectToken();
  const utm_source = localStorage.getItem("source")
    ? localStorage.getItem("source")
    : "web";

    const isMobileView = useMemo(() => {
      return isMobile(window.innerWidth);
    }, [window.innerWidth]);

  const selectedPolicyDetail =
    JSON.parse(localStorage.getItem("selectedPolicy")) || {};

  let authHeader = {
    headers: {
      authtoken: props.accessToken,
      subscriptionid:
        selectedPolicyDetail?.primarySubscriptionId ??
        OPDConfig.Old_Policy_SubscriptionId,
      entitypolicyid:
        selectedPolicyDetail?.entityPolicyId ??
        OPDConfig.Old_Policy_EntityPolicyId,
    },
  };

  useEffect(() => {
    if (userDetails?.firstName) setUserName(userDetails.firstName);
  }, [userDetails, setUserName]);

  useEffect(() => {
    if (Array.isArray(userPolicies)) setUserPoliciesCtx(userPolicies);
  }, [userPolicies, setUserPoliciesCtx]);

  useEffect(() => {
    if (selectedPolicyId != null) setSelectedPolicyIdCtx(selectedPolicyId);
  }, [selectedPolicyId, setSelectedPolicyIdCtx]);


  useEffect(() => {
  if (selectedPolicyIdCtx && selectedPolicyIdCtx !== selectedPolicyId) {
    setSelectedPolicyId(selectedPolicyIdCtx);
  }
}, [selectedPolicyIdCtx]);

  const isSubeno = HIDE_BENEFITS_SECTIONS_ENTITY_ID_LIST.includes(
    parseInt(getUserDetails(PM_ENTITY_ID))
  );

useEffect(() => {
  const masPopupShown = localStorage.getItem('masPopupShown');
  const isWiproEntity = WIPRO_ENTITY_ID_LIST.includes(
    parseInt(getUserDetails("pmentityid"))
  );
  
  if (isMobileView && isWiproEntity && claim && ledger) {
    if (!masPopupShown) {
      setShowMasPolicyPopup(true);
      setMasPolicyCollapsed(false);
    } else {
      setMasPolicyCollapsed(true);
      setShowMasPolicyPopup(false);
    }
  }
  if (!isMobileView && isWiproEntity && claim && ledger) {
    setMasPolicyCollapsed(false);
    setShowMasPolicyPopup(false);
  }
}, [claim, ledger, isMobileView]);

useEffect(() => {
  const nestleKeyNotesPopupShown = localStorage.getItem(KEY_NOTES_POPUP_NESTLE);
  const isNestleEntity = NESTLE_ENTITY_ID_LIST.includes(
    parseInt(getUserDetails(PM_ENTITY_ID))
  );

  if (!(isNestleEntity && claim && ledger)) return;

  if (isMobileView) {
    const shouldShowPopup = !nestleKeyNotesPopupShown;

    setShowNestleKeyNotesPopup(shouldShowPopup);
    setNestleKeyNotesCollapsed(!shouldShowPopup);
  } else {
    setNestleKeyNotesCollapsed(false);
    setShowNestleKeyNotesPopup(false);
  }

}, [claim, ledger, isMobileView]);

useEffect(() => {
  if (tabSwitching && claim && ledger) {
    setTimeout(() => {
      setTabSwitching(false);
    }, 150);
  }
}, [claim, ledger, tabSwitching, setTabSwitching]);

const handleMasPolicyGotIt = () => {
  setShowMasPolicyPopup(false);
  setMasPolicyCollapsed(true);
  localStorage.setItem('masPopupShown', 'true');
};

const handleCollapsedCardClick = () => {
  setShowMasPolicyPopup(true);
};

const handleNestleKeyNotesGotIt = () => {
  setShowNestleKeyNotesPopup(false);
  setNestleKeyNotesCollapsed(true);
  localStorage.setItem(KEY_NOTES_POPUP_NESTLE, 'true');
};

const handleNestleKeyNotesCollapsedCardClick = () => {
  setShowNestleKeyNotesPopup(true);
};

 const isAdobeEntity = ADOBE_ENTITY_ID_LIST.includes(
    parseInt(getUserDetails(PM_ENTITY_ID))
  );
useEffect(() => {
  const adobeKeyNotesPopupShown = localStorage.getItem(KEY_NOTES_POPUP_ADOBE);
 
  if (!(isAdobeEntity && claim && ledger)) return;

  if (isMobileView) {
    const shouldShowPopup = !adobeKeyNotesPopupShown;

    setShowAdobeKeyNotesPopup(shouldShowPopup);
    setAdobeKeyNotesCollapsed(!shouldShowPopup);
  } else {
    setAdobeKeyNotesCollapsed(false);
    setShowAdobeKeyNotesPopup(false);
  }

}, [claim, ledger, isMobileView]);

const handleAdobeKeyNotesGotIt = () => {
  setShowAdobeKeyNotesPopup(false);
  setAdobeKeyNotesCollapsed(true);
  localStorage.setItem(KEY_NOTES_POPUP_ADOBE, 'true');
};

const handleAdobeKeyNotesCollapsedCardClick = () => {
  setShowAdobeKeyNotesPopup(true);
};

const handleDateSort = () => {
  setSortLoading(true);
  
  setTimeout(() => {
    if (dateSort === null || dateSort === 'desc') {
      setDateSort('asc');
    } else {
      setDateSort('desc');
    }
    setSortLoading(false);
  }, 300);
};

const sortedClaims = useMemo(() => {
  if (!dateSort || !claim) return claim;
  
  return [...claim].sort((a, b) => {
    const dateA = new Date(a.createddate);
    const dateB = new Date(b.createddate);
    
    if (dateSort === 'asc') {
      return dateA - dateB;
    } else {
      return dateB - dateA;
    }
  });
}, [claim, dateSort]);

  const ledgerandClaimDetails = async (
    entitypolicyid,
    selectedPolicyDetail
  ) => {

    if (
      entitypolicyid &&
      selectedPolicyDetail
    ) {
      authHeader.headers.entitypolicyid = entitypolicyid;
      authHeader.headers.subscriptionid =
        selectedPolicyDetail?.primarySubscriptionId;
    }
    try {
      const claimDetails = await axiosInstance.get(
        `${apiUrl}/claimDetails/getClaimDraft`,authHeader
      );
      if (claimDetails.status === 200) {
        if (claimDetails.data.isSuccess === true) {
          setClaim(claimDetails.data.result);
          setUserDetails(claimDetails.data.employeeDetails);
          localStorage.setItem(
            USER_DETAILS_KEY,
            JSON.stringify(
              prepareUserDetails(claimDetails.data.employeeDetails.result)
            )
          );
        }
        if (claimDetails.data.isSuccess === false) {
          if (claimDetails.data.message === "auth token is expired") {
            setShowLoginAction(true);
            setMessage("Session expired please login again");
          } else {
            setShowLoginAction(false);
            setMessage(
              "We couldn't load at this moment. Press back and navigate back to this page"
            );
          }
          setLoading(false);
        }
      } else {
        setLoading(false);
        setShowLoginAction(false);
        setMessage("Unable to fetch your claims");
        localStorage.removeItem(USER_DETAILS_KEY);
      }
    } catch (error) {
      setLoading(false);
      localStorage.removeItem(USER_DETAILS_KEY);
      if (error.response.data.message === "Token_Expired") {
        setShowLoginAction(true);
        setMessage("Session expired please login again");
      } else {
        setShowLoginAction(false);
        setMessage("Unable to fetch your claims");
      }
    }

    try {
      const ledgerDetails = await axiosInstance.get(
        `${apiUrl}/claimDetails/V2/claim-ledger`,authHeader
      );

      if (ledgerDetails.status === 200) {
        const data = ledgerDetails.data;

        // New API shape detection: presence of categories/amounts without isSuccess/result
        const isNewApi = Array.isArray(data?.categories) || Array.isArray(data?.amounts);

        if (isNewApi) {
          // Set ledger with helpful fallbacks/mappings
          const normalizedLedger = {
            amounts: data?.amounts || [],
            categories: data?.categories || [],
            showBalances: Boolean(data?.showBalances),
            // Map corpWalletBal to walletBalance for downstream use if needed
            walletBalance: data?.walletBalance ?? data?.corpWalletBal,
          };
          setLedger(normalizedLedger);

          // Build reimbursement limits from categories
          setReimbursementLimits(() => {
            const claimsLimits = { limits: [], showBalance: Boolean(data?.showBalances) };
            (data?.categories || []).forEach((cat, index) => {
              const categoryLimit = {
                category: cat.category,
                limit: cat.eligibleLimit,
                balance: claimsLimits.showBalance ? cat.availableBalance : undefined,
                // for alternating bg color, mimic old 'group' using index
                group: index % 2,
              };
              claimsLimits.limits.push(categoryLimit);
            });
            return claimsLimits;
          });

          // Synthesize legacy localStorage entries expected by other screens (e.g., ClaimLanding)
          try {
            const legacyEligibleColumns = (data?.categories || []).map((cat, index) => ({
              // minimal set used downstream
              category: cat.category,
              categorylimit: cat.eligibleLimit,
              group: index % 2,
              // stringify to match old API contract
              dynamic_labelling: JSON.stringify(cat.dynamicLabels || {}),
            }));
            localStorage.setItem("eligibleColumns", JSON.stringify(legacyEligibleColumns));

            // Build benefMappedServices as relationId -> array of categories
            const relationToItems = {};
            (data?.categories || []).forEach((cat, index) => {
              const relationIds = Array.isArray(cat.relationIds) ? cat.relationIds : [];
              relationIds.forEach((relId) => {
                if (!relationToItems[relId]) relationToItems[relId] = [];
                relationToItems[relId].push({
                  category: cat.category,
                  categorylimit: cat.eligibleLimit,
                  group: index % 2,
                  dynamic_labelling: JSON.stringify(cat.dynamicLabels || {}),
                });
              });
            });
            localStorage.setItem("benefMappedServices", JSON.stringify(relationToItems));
          } catch (_) {}

          // Persist categories for downstream consumers (e.g., Claim form dynamicBill)
          try {
            localStorage.setItem("categoriesV2", JSON.stringify(data?.categories || []));
          } catch (_) {}

          // Store pennyDropEnabled for autopay popup logic
          try {
            localStorage.setItem(LocalStorageKeys.PENNY_DROP_ENABLED, data?.pennyDropEnabled ? "true" : "false");
          } catch (_) {}

          // Summary from first category dynamic label if present
          const firstDynamicSummary = data?.categories?.[0]?.dynamicLabels?.dynamic_summary;
          if (firstDynamicSummary) {
            setSummary(firstDynamicSummary);
          }

          // New response doesn't include maintenance or entity checks; skip safely
          setLoading(false);
        } else if (data?.isSuccess === true && data?.result) {
          // Old API handling
          if (data.result?.EligibleColumn?.[0]?.isundermaintenance) {
            setShowLoginAction(false);
            setMessage(
              "Server is under maintenance. Kindly avail your reimbursements after a few hours.Inconvenience is regretted."
            );
            setisundermaintenance(1);
            setLoading(false);
          }
          setLedger(data.result);

          setReimbursementLimits(() => {
            let claimsLimits = { limits: [], showBalance: false };
            if (data.result.availableBalanceContractWise) {
              claimsLimits.showBalance = true;
            }
            data.result.EligibleColumn?.forEach((item, index) => {
              let categoryLimit = {
                category: item.category,
                limit: item.categorylimit,
                balance: undefined,
                group: item.group ?? (index % 2),
              };
              if (
                data.result.availableBalanceContractWise &&
                (data.result.availableBalanceContractWise[item.category] !== undefined ||
                  data.result.availableBalanceContractWise[item.category] !== null)
              ) {
                categoryLimit.balance =
                  data.result.availableBalanceContractWise[item.category];
              }
              claimsLimits.limits.push(categoryLimit);
            });
            return claimsLimits;
          });

          // Guarded localStorage writes for old response keys
          if (data.result?.EligibleColumn) {
            localStorage.setItem(
              "eligibleColumns",
              JSON.stringify(data.result.EligibleColumn)
            );
          }
          if (data.result?.benefMappedServices) {
            localStorage.setItem(
              "benefMappedServices",
              JSON.stringify(data.result.benefMappedServices)
            );
          }

          // Store pennyDropEnabled for autopay popup logic (old API)
          try {
            localStorage.setItem(LocalStorageKeys.PENNY_DROP_ENABLED, data.result?.pennyDropEnabled ? "true" : "false");
          } catch (_) {}

          if (data.result?.EligibleColumn?.[0]?.pmentityid === 11185545) {
            setEntityIdCheck(true);
          }

          if (data.result?.EligibleColumn?.[0]?.dynamic_labelling) {
            try {
              let dynamic_label = JSON.parse(
                data.result.EligibleColumn[0].dynamic_labelling
              );
              if (dynamic_label?.dynamic_summary) {
                setSummary(dynamic_label.dynamic_summary);
              }
            } catch (_) {}
          }
        } else if (data?.isSuccess === false) {
          if (data.message === "auth token is expired") {
            setShowLoginAction(true);
            setMessage("Session expired please login again");
          } else if (data.message === "blocked") {
            setShowLoginAction(false);
            setMessage(
              "Server is under maintenance. Kindly avail your reimbursements after a few hours. Inconvenience is regretted."
            );
          } else {
            setShowLoginAction(false);
            setMessage(
              "We couldn't load at this moment. Press back and navigate back to this page"
            );
          }
          setLoading(false);
        } else {
          // Unknown successful payload
          setLedger(data);
          setLoading(false);
        }
      } else {
        setLoading(false);
        setShowLoginAction(false);
        setMessage("Unable to fetch your claims");
      }
    } catch (error) {
      setLoading(false);
      if (error.response.data.message === "Token_Expired") {
        setShowLoginAction(true);
        setMessage("Session expired please login again");
      } else {
        setShowLoginAction(false);
        setMessage("Unable to fetch your claims");
      }
    }
  };

const showBalances = ledger?.showBalances;
const columnWidths = showBalances ? ['50%', '25%', '25%'] : ['60%', '40%'];

  const getPoliciesForUser = async () => {
    try {
      const policies = await axiosInstance.get(`${apiUrl}/opd/getPolicies`, authHeader);
      if (policies.status === 200 && policies?.data?.length) {
        const policyArray = policies?.data;
        if (policyArray.length) {
          setUserPolicies(policyArray);
          const isSelectedPolicy = policyArray?.find(
            (policy) => policy.entityPolicyId == selectedPolicyId
          );
          isSelectedPolicy
            ? setSelectedPolicy(isSelectedPolicy)
            : setSelectedPolicy(policyArray[0]);
        } else {
          setLoading(false);
          setShowLoginAction(true);
          setMessage(
            "We couldn't retrieve your policies. Please log in again with your company account and try once more."
          );
        }
      } else {
        setLoading(false);
        setShowLoginAction(true);
        setMessage(
          "We couldn't retrieve your policies. Please log in again with your company account and try once more."
        );
      }
    } catch (error) {
      setLoading(false);
      if (error.response?.data?.message === "Token_Expired") {
        setShowLoginAction(true);
        setMessage("Session expired please login again");
      } else {
        setShowLoginAction(true);
        setMessage(
          "We couldn't retrieve your policies. Please log in again with your company account and try once more."
        );
      }
    }
  };

  const CreateClaim = () => {
    sessionStorage.removeItem("relationName");
    trackEvent.createClaim({ screenName: ScreenName.CREATE_CLAIM });
    navigate("/reimbursements/claim");
  };

  const redirectAndLogEvent = (url, page, serviceName, altText) => {
    try {
      // Log to console for debugging
      const eventLogUrl = process.env.REACT_APP_EVENT_LOG_URL;
      const utm_source = localStorage.getItem("source")
        ? localStorage.getItem("source")
        : "web";
      // Track the banner click using the appropriate tracking function based on location
      if (page === pageConfigurationPageIDs.YOUR_CLAIMS_PAGE) {
        trackEvent.claimBannerClick({ screenName: ScreenName.YOUR_CLAIMS, name: ScreenName.YOUR_CLAIMS, bannerName: altText });
      } else if (page === pageConfigurationPageIDs.SUMMARY_PAGE) {
        trackEvent.homeBannerClick({ screenName: ScreenName.SUMMARY, name: ScreenName.SUMMARY, bannerName: altText });
      }
      let meta = {
        utm_source: utm_source,
        userEmployeeId: userDetails.employeeId,
        pmEntityId: userDetails.entityId,
        email: userDetails.emailId,
        firstName: userDetails.firstName,
      };
      const eventLogPayload = {
        userId: userDetails.mbUserId,
        event: page,
        info: page,
        meta: JSON.stringify(meta),
        serviceName: serviceName,
        appversion: utm_source,
        landedFrom: "Reimbursement Landing Page",
      };
      setTimeout(() => {
        if (isWebView()) {
        if (taskDeviceBridge && taskDeviceBridge.launchDeepLink) {
          taskDeviceBridge.launchDeepLink(url);
        }
      } else {
        window.location.href = url;
      }

      axios.post(eventLogUrl, eventLogPayload);

      }, 300);
    } catch (error) {
      console.error(error)
      return;
    }
  };

  useEffect(() => {
    const fetchPolicies = async () => {
      if (token) {
        await getPoliciesForUser();
      }
    };
    
    fetchPolicies();
  }, [token]);



useEffect(() => {
  const newSelectedPolicy = userPolicies?.find(
    (policy) => policy.entityPolicyId == selectedPolicyId
  );
  
  if (newSelectedPolicy) {
    setSelectedPolicy(newSelectedPolicy);
    localStorage.setItem("entityPolicyId", selectedPolicyId);
    localStorage.setItem("selectedPolicy", JSON.stringify(newSelectedPolicy));
    
    if (selectedPolicyId !== selectedPolicyIdCtx) {
      setSelectedPolicyIdCtx(selectedPolicyId);
    }
  }
}, [selectedPolicyId, userPolicies]);


 useEffect(() => {
  if (selectedPolicy && selectedPolicy.entityPolicyId) {
    setLoading(true);
    setClaim(null);
    setLedger(null);
    setReimbursementLimits([]);
    setSummary(null);
    
    const selectedPolicyReimbursementEndDate = selectedPolicy?.reimbursementEndDate;

    if (!isValidReimbursementEndDate(selectedPolicyReimbursementEndDate)) {
      setCreateClaimDisable(true);
    } else {
      setCreateClaimDisable(false);
    }
    
    ledgerandClaimDetails(selectedPolicy.entityPolicyId, selectedPolicy);
  }
}, [selectedPolicy]);




  function capitalizeFirstLetter(str) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#D6E8FF",
      color: "#050A4E",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const isValidReimbursementEndDate = (dateString) => {
    return isValidDate(dateString) && new Date(dateString) > new Date();
  };

  const isValidDate = (dateString) => !isNaN(Date.parse(dateString));

  const bannerClickHandler = handleBannerClick(token, props.accessToken)(redirectAndLogEvent)

  const handlePolicyChange = (eventKey) => {
  setLoading(true);
  setSelectedPolicyId(eventKey);
  setSelectedPolicyIdCtx(eventKey);
};

  return (
    <>
      <Backdrop
        sx={{
          color: "#FFFFFF",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
        }}
        open={sortLoading || tabSwitching}
      >
        <CircularProgress color="inherit" size={50} thickness={4} />
      </Backdrop>
      <Row
        className="pd-lf-15"
        style={{
          paddingBottom: isMobileView ? "100px" : "0",
        }}
      >
        <div className="right-sec-hdr">
          <div className="flex show-flex-direction-opp">
            <Col
              md={12}
              className="details-claims flex justify-content-space-between"
            >
              {!isMobileView && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "16px",
                      padding: "8px 0 10px",
                      width: "100%",
                    }}
                  >
                    <Typography
                      component="h1"
                      tabIndex="0"
                      style={{
                        margin: 0,
                        flex: 1,
                        fontSize: "20px",
                        lineHeight: "24px",
                        fontWeight: 600,
                        color: "#252D38",
                      }}
                    >
                      Reimbursement Overview
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      marginLeft: "auto",
                    }}
                  >
                    <div className="p-0">
                      <Dropdown
                        className="dropDown"
                        aria-label="Select Policy"
                        onSelect={handlePolicyChange}
                      >
                        <Dropdown.Toggle
                          variant="outline-secondary"
                          id="dropdown-basic"
                          style={{
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #DBE0E6",
                            borderRadius: "8px",
                            padding: "10px 16px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#252D38",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            minWidth: isMobileView ? "100%" : "300px",
                            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                          }}
                        >
                          {selectedPolicy
                            ? selectedPolicy.policyName
                            : "Select Policy"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            borderRadius: "8px",
                            border: "1px solid #DBE0E6",
                            boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.1)",
                            padding: "8px 0",
                            minWidth: isMobileView ? "100%" : "300px",
                          }}
                        >
                          {userPolicies.map((policy) => (
                            <Dropdown.Item
                              key={policy?.entityPolicyId}
                              eventKey={policy?.entityPolicyId}
                              active={
                                policy?.entityPolicyId == selectedPolicyId
                              }
                              style={{
                                padding: "10px 16px",
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#252D38",
                                backgroundColor: "#E7F3FF",
                              }}
                            >
                              {policy?.policyName}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="text-right pd-ver-20">
                      <Button
                        id="create-claim-btn"
                        variant="primary"
                        style={{
                          backgroundColor:
                            entityidCheck || createClaimDisable
                              ? "#d9d9d9"
                              : "#0066DC",
                          border: "none",
                          cursor: createClaimDisable
                            ? "not-allowed"
                            : "pointer",
                          borderRadius: isMobileView ? "12px" : "8px",
                          padding: isMobileView ? "14px 24px" : "12px 24px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#FFFFFF",
                          width: isMobileView ? "100%" : "auto",
                          minWidth: isMobileView ? "100%" : "180px",
                          boxShadow: "0 2px 8px 0 rgba(0, 102, 220, 0.24)",
                          transition: "all 0.2s ease",
                        }}
                        className={
                          entityidCheck || createClaimDisable
                            ? "disabled"
                            : "border-radius-10"
                        }
                        onClick={CreateClaim}
                        disabled={entityidCheck || createClaimDisable}
                      >
                        Create Claim
                      </Button>
                    </div>
                  </div>
                </>
              )}
              {isMobileView && (
                <div className="text-right pd-ver-20 mobile-create-claim-footer">
                  <Button
                    id="create-claim-btn"
                    variant="primary"
                    style={{
                      backgroundColor:
                        entityidCheck || createClaimDisable
                          ? "#d9d9d9"
                          : "#0066DC",
                      border: "none",
                      cursor: createClaimDisable ? "not-allowed" : "pointer",
                      borderRadius: isMobileView ? "12px" : "8px",
                      padding: isMobileView ? "14px 24px" : "12px 24px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#FFFFFF",
                      width: isMobileView ? "100%" : "auto",
                      minWidth: isMobileView ? "100%" : "180px",
                      boxShadow: "0 2px 8px 0 rgba(0, 102, 220, 0.24)",
                      transition: "all 0.2s ease",
                    }}
                    className={
                      entityidCheck || createClaimDisable
                        ? "disabled"
                        : "border-radius-10"
                    }
                    onClick={CreateClaim}
                    disabled={entityidCheck || createClaimDisable}
                  >
                    Create Claim
                  </Button>
                </div>
              )}
            </Col>
          </div>
        </div>

        {claim && ledger && !isundermaintenance ? (
          <>
            {flag ? (
              <>
                <Carousel
                  itemClassnames={"r2cBanner"}
                  pageId={pageConfigurationPageIDs.YOUR_CLAIMS_PAGE}
                  carouselId={
                    pageConfigurationCarouselIDs.REIM_YOUR_CLAIMS_CAROUSEL
                  }
                  bannerOnClick={bannerClickHandler}
                />
                <Typography
                  style={{
                    fontWeight: "600",
                    fontSize: "18px",
                    marginTop: "20px",
                    marginBottom: "15px",
                    textAlign: "left",
                    color: "#252D38",
                  }}
                  variant="h2"
                  tabIndex="0"
                >
                  All Claims
                </Typography>
                {claim.length > 0 ? (
                  <div className="pd-rt-0 pd-xs-0">
                    <Paper
                      sx={{
                        width: "100%",
                        overflow: "hidden",
                        borderRadius: "15px",
                      }}
                    >
                      <TableContainer
                        sx={{
                          border: "1px solid #DBE0E6",
                          borderRadius: "15px",
                        }}
                      >
                        <Table
                          responsive="md"
                          stickyHeader
                          aria-label="sticky table"
                          ariaLabel="customized table"
                        >
                          <TableHead>
                            <TableRow>
                              <StyledTableCell
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#F5F7F8",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    color: "#252D38",
                                    fontWeight: "500",
                                  }}
                                >
                                  Claim ID.
                                  <Tooltip
                                    title="Tap on Claim ID to View Details"
                                    placement="top"
                                    arrow
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          backgroundColor: "#2E3742",
                                          color: "#FFFFFF",
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          padding: "12px 16px",
                                          borderRadius: "8px",
                                          boxShadow:
                                            "0 0 10px 0 rgba(0, 0, 0, 0.02)",
                                        },
                                      },
                                      arrow: {
                                        sx: {
                                          color: "#2E3742",
                                        },
                                      },
                                    }}
                                  >
                                    <InfoOutlined
                                      style={{
                                        fontSize: "16px",
                                        color: "#47566A",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </Tooltip>
                                </div>
                              </StyledTableCell>
                              <StyledTableCell
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#F5F7F8",
                                  color: "#252D38",
                                  fontWeight: "500",
                                }}
                              >
                                Patient Name
                              </StyledTableCell>
                              <StyledTableCell
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#F5F7F8",
                                  color: "#252D38",
                                  fontWeight: "500",
                                }}
                              >
                                Status
                              </StyledTableCell>
                              <StyledTableCell
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#F5F7F8",
                                  color: "#252D38",
                                  fontWeight: "500",
                                }}
                              >
                                Claimed
                              </StyledTableCell>
                              <StyledTableCell
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  backgroundColor: "#F5F7F8",
                                  color: "#252D38",
                                  fontWeight: "500",
                                }}
                              >
                                Approved
                              </StyledTableCell>
                              <StyledTableCell
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "#F5F7F8",
                                  color: "#252D38",
                                  fontWeight: "500",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  Created On
                                  <UnfoldMoreIcon
                                    onClick={handleDateSort}
                                    style={{
                                      fontSize: "15px",
                                      color: "#252D38",
                                      cursor: "pointer",
                                      transform:
                                        dateSort === "asc"
                                          ? "rotate(180deg)"
                                          : "none",
                                      transition: "all 0.2s ease",
                                    }}
                                  />
                                </div>
                              </StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sortedClaims.map((row) => (
                              <TableRow key={row.claimid} hover tabIndex={-1}>
                                <TableCell scope="row">
                                  <Link
                                    to={`/reimbursements/claimdetails/${row.claimid}`}
                                    className="claim-id-link"
                                    style={{
                                      color: "#004FB6",
                                      textDecoration: "underline",
                                      textDecorationStyle: "solid",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {row.claimid}
                                  </Link>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "#47566A",
                                    fontWeight: "400",
                                  }}
                                >
                                  {row.name}
                                </TableCell>
                                <TableCell>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "8px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        color: "#47566A",
                                        textTransform: "capitalize",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {row.remarks === "pre approved" ||
                                      row.remarks === "pre rejected" ||
                                      row.remarks ===
                                        "partially pre approved" ||
                                      row.remarks === "recheck"
                                        ? "under process"
                                        : row.remarks === "information required"
                                        ? "Information Required"
                                        : row.remarks}
                                    </span>
                                    {row.remarks?.toLowerCase() ===
                                    "information required" ? (
                                      <Link
                                        to={`/reimbursements/informationneeded/${row.claimid}`}
                                        style={{
                                          color: "#AE0006",
                                          textDecoration: "none",
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "2px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Re-Submit
                                        <ArrowForwardIosIcon
                                          style={{ fontSize: "14px" }}
                                        />
                                      </Link>
                                    ) : (
                                      <Link
                                        to={`/reimbursements/claimdetails/${row.claimid}`}
                                        style={{
                                          color: "#004FB6",
                                          textDecoration: "none",
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "2px",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        View Claim
                                        <ArrowForwardIosIcon
                                          style={{ fontSize: "14px" }}
                                        />
                                      </Link>
                                    )}
                                  </div>
                                </TableCell>

                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "#47566A",
                                    fontWeight: "400",
                                  }}
                                >
                                  ₹{Number(row.claimamount).toFixed(2)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "#47566A",
                                    fontWeight: "400",
                                  }}
                                >
                                  ₹
                                  {Number(
                                    row.remarks === "pre approved" ||
                                      row.remarks === "pre rejected" ||
                                      row.remarks ===
                                        "partially pre approved" ||
                                      row.remarks === "resubmitted" ||
                                      row.remarks === "recheck" ||
                                      row.remarks === "information required"
                                      ? 0
                                      : row.approvedclaimamount
                                  ).toFixed(2)}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "#47566A",
                                    fontWeight: "400",
                                  }}
                                >
                                  {row.createddate
                                    ? new Date(
                                        row.createddate
                                      ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      }) +
                                      " | " +
                                      new Date(
                                        row.createddate
                                      ).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                      })
                                    : "N/A"}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                    <br></br>
                    <br></br>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: isMobileView ? "150px" : "200px",
                      padding: "40px 20px",
                      backgroundColor: "#F5F7F8",
                      borderRadius: "8px",
                      border: "1px solid #DBE0E6",
                      marginBottom: "20px",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: isMobileView ? "14px" : "16px",
                        fontWeight: "400",
                        color: "#47566A",
                        textAlign: "center",
                      }}
                    >
                      No claims yet for this policy year
                    </Typography>
                  </div>
                )}
                <div className="queries-new-right">
                  <div className="queries-header">
                    <b>Need help with Claim?</b>
                  </div>
                  <div className="queries-content">
                    <p>
                      If you have any questions or concerns about your OPD
                      claims, just drop us an email at{" "}
                      <strong>{getCustomerSupportEmailId()}</strong>. Our
                      support team will get back to you as soon as possible to
                      help you out.
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <div>
                <Carousel
                  itemClassnames={"r2cBanner"}
                  pageId={pageConfigurationPageIDs.SUMMARY_PAGE}
                  carouselId={
                    pageConfigurationCarouselIDs.REIM_SUMMARY_CAROUSEL
                  }
                  bannerOnClick={bannerClickHandler}
                />
                <Row hidden={!entityidCheck} style={{ marginBottom: "12px" }}>
                  <Col>
                    <div className="note-container">
                      Reimbursements are temporarily disabled for Wells Fargo
                      employees. You can access your outpatient benefits by
                      using the cashless feature on the Medibuddy App. In case
                      of any queries, please reach out to us at
                      {getCustomerSupportEmailId()} or call us at +91
                      9999991555.
                    </div>
                  </Col>
                </Row>
                <Dialog
                  open={
                    isMobileView &&
                    showMasPolicyPopup &&
                    WIPRO_ENTITY_ID_LIST.includes(
                      parseInt(getUserDetails("pmentityid"))
                    )
                  }
                  onClose={() => {}}
                  maxWidth="sm"
                  fullWidth
                  disableEscapeKeyDown
                  PaperProps={{
                    sx: {
                      borderRadius: "20px",
                      margin: "16px",
                      maxHeight: "85vh",
                    },
                  }}
                >
                  <DialogContent
                    sx={{
                      padding: "32px 24px 24px 24px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        overflowY: "auto",
                        overflowX: "hidden",
                        maxHeight: "calc(85vh - 140px)",
                        paddingRight: "8px",
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "17px",
                          fontWeight: "600",
                          color: "#252D38",
                          marginBottom: "16px",
                        }}
                      >
                        Key Updates on MAS Policy Changes for FY {getMasFiscalYear(selectedPolicy)}
                      </Typography>

                      <ol style={{ paddingLeft: "20px", margin: 0 }}>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#47566A",
                            lineHeight: "1.6",
                          }}
                        >
                          Pathology Lab Tests & Diagnostics (including blood,
                          urine, and stool tests) will now be covered
                          exclusively via the cashless mode and will not be
                          eligible for reimbursement.
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#47566A",
                            lineHeight: "1.6",
                          }}
                        >
                          Vision-related expenses (including frames and lenses)
                          will also be covered only through the cashless mode
                          and will not be reimbursable.
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#47566A",
                            lineHeight: "1.6",
                          }}
                        >
                          Disclaimer for Emergency Pathology - Employees must
                          submit a valid prescription, including the diagnosis
                          and a "brief history" of presenting complaints
                          justifying the emergent investigation, along with the
                          reports and lab tests availed within six hours of the
                          prescription. Additionally, a follow-up prescription
                          from the doctor for the same reports within 24 hours
                          of the reports or primary consultation may be
                          required. Further documentation may be requested to
                          determine the emergency status. Digital App orders and
                          home collection orders will not be approved. Final
                          approval is subject to interpretation by the
                          adjudicating doctor.
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#47566A",
                            lineHeight: "1.6",
                          }}
                        >
                          Dental - Root canal treatments are covered under
                          Wipro's Group Medical Insurance. Please claim the
                          expenses through your group medical coverage. Any
                          remaining balance can be handled via MAS benefits. Be
                          sure to submit the GMC settlement letter to process
                          the claim.
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#47566A",
                            lineHeight: "1.6",
                          }}
                        >
                          Medicines - For chronic ailments, a valid prescription
                          issued within 1 year is required. For other ailments,
                          a prescription issued within the last six months is
                          needed. You can also obtain a prescription by using
                          the online consultations available through the
                          MediBuddy platform.
                        </li>
                        <li
                          style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#47566A",
                            lineHeight: "1.6",
                          }}
                        >
                          Reimbursement is permitted under specific conditions
                          subject to the verification and approval by MediBuddy:
                          <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
                            <li style={{ marginBottom: "8px" }}>
                              Pathology: Tests for children under 6 years or
                              when home visits and lab centres are unavailable
                              in your area, and tests not listed on the
                              MediBuddy platform.
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              Vision: For specialized lenses/contact lenses not
                              available with empanelled partners (Lenskart,
                              Specsmakers, Vision Express), or when vision
                              partners are unavailable in your area.
                            </li>
                          </ul>
                        </li>
                      </ol>

                      <Typography
                        style={{
                          fontSize: "14px",
                          color: "#252D38",
                          marginTop: "16px",
                          lineHeight: "1.6",
                        }}
                      >
                        For any questions or clarifications, please reach out to{" "}
                        <strong>wipro.support@medibuddy.in</strong> or call us
                        at <strong>+91 9999991555</strong>.
                      </Typography>
                    </div>
                  </DialogContent>

                  <DialogActions
                    sx={{
                      padding: "16px 24px 32px 24px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      onClick={handleMasPolicyGotIt}
                      variant="contained"
                      style={{
                        backgroundColor: "#0066DC",
                        color: "#FFFFFF",
                        borderRadius: "12px",
                        padding: "12px 48px",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "none",
                        minWidth: "250px",
                      }}
                    >
                      Got it
                    </Button>
                  </DialogActions>
                </Dialog>

                <Row
                  hidden={
                    isMobileView ||
                    !showMasPolicy ||
                    !WIPRO_ENTITY_ID_LIST.includes(
                      parseInt(getUserDetails("pmentityid"))
                    )
                  }
                  style={{ marginBottom: "12px" }}
                >
                  <Col>
                    <div
                      style={{
                        position: "relative",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        className="note-container-mas"
                        style={{
                          position: "relative",
                          height: "220px",
                          maxHeight: "220px",
                          overflowY: "scroll",
                          overflowX: "hidden",
                          padding: "16px",
                          paddingBottom: "24px",
                          backgroundColor: "#F5F7F8",
                          borderRadius: "8px",
                          border: "1px solid #DBE0E6",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          scrollbarWidth: "thin",
                          scrollbarColor: "#888 #F5F7F8",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "500",
                            color: "#252D38",
                            paddingRight: "30px",
                            marginBottom: "12px",
                            paddingLeft: "8px",
                          }}
                        >
                          Key Updates on MAS Policy Changes for FY {getMasFiscalYear(selectedPolicy)}
                        </p>
                        <ul
                          style={{
                            fontSize: "15px",
                            fontWeight: "400",
                            lineHeight: "1.6",
                            color: "#252D38",
                            paddingLeft: "20px",
                            margin: 0,
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>
                            Pathology Lab Tests & Diagnostics (including blood,
                            urine, and stool tests) will now be covered
                            exclusively via the cashless mode and will not be
                            eligible for reimbursement.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Vision-related expenses (including frames and
                            lenses) will also be covered only through the
                            cashless mode and will not be reimbursable.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Disclaimer for Emergency Pathology - Employees must
                            submit a valid prescription, including the diagnosis
                            and a "brief history" of presenting complaints
                            justifying the emergent investigation, along with
                            the reports and lab tests availed within six hours
                            of the prescription. Additionally, a follow-up
                            prescription from the doctor for the same reports
                            within 24 hours of the reports or primary
                            consultation may be required. Further documentation
                            may be requested to determine the emergency status.
                            Digital App orders and home collection orders will
                            not be approved. Final approval is subject to
                            interpretation by the adjudicating doctor.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Dental - Root canal treatments are covered under
                            Wipro's Group Medical Insurance. Please claim the
                            expenses through your group medical coverage. Any
                            remaining balance can be handled via MAS benefits.
                            Be sure to submit the GMC settlement letter to
                            process the claim.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Medicines - For chronic ailments, a valid
                            prescription issued within 1 year is required. For
                            other ailments, a prescription issued within the
                            last six months is needed. You can also obtain a
                            prescription by using the online consultations
                            available through the MediBuddy platform.
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            Reimbursement is permitted under specific conditions
                            subject to the verification and approval by
                            MediBuddy:
                            <ul
                              style={{ paddingLeft: "20px", marginTop: "8px" }}
                            >
                              <li style={{ marginBottom: "8px" }}>
                                Pathology: Tests for children under 6 years or
                                when home visits and lab centres are unavailable
                                in your area, and tests not listed on the
                                MediBuddy platform.
                              </li>
                              <li style={{ marginBottom: "8px" }}>
                                Vision: For specialized lenses/contact lenses
                                not available with empanelled partners
                                (Lenskart, Specsmakers, Vision Express), or when
                                vision partners are unavailable in your area.
                              </li>
                            </ul>
                          </li>
                        </ul>

                        <p
                          style={{
                            fontSize: "15px",
                            fontWeight: "400",
                            lineHeight: "1.6",
                            color: "#252D38",
                            marginTop: "16px",
                            paddingLeft: "0px",
                          }}
                        >
                          For any questions or clarifications, please reach out
                          to <strong>wipro.support@medibuddy.in</strong> or call
                          us at <strong>+91 9999991555</strong>.
                        </p>
                      </div>

                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: "60px",
                          background:
                            "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #F5F7F8 59.09%)",
                          borderRadius: "0 0 8px 8px",
                          pointerEvents: "none",
                          borderRight: "1px solid #DBE0E6",
                          borderBottom: "1px solid #DBE0E6",
                          borderLeft: "1px solid #DBE0E6",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row
                  hidden={
                    !isMobileView ||
                    !masPolicyCollapsed ||
                    !WIPRO_ENTITY_ID_LIST.includes(
                      parseInt(getUserDetails("pmentityid"))
                    )
                  }
                  style={{ marginBottom: "12px" }}
                >
                  <Col>
                    <div
                      onClick={handleCollapsedCardClick}
                      style={{
                        position: "relative",
                        padding: "14px 16px",
                        backgroundColor: "#FFFFFF",
                        borderRadius: "12px",
                        border: "1px solid #DBE0E6",
                        boxShadow: " 0 1px 4px 0 rgba(0, 0, 0, 0.04)",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 4px 8px rgba(0, 0, 0, 0.12)";
                        e.currentTarget.style.borderColor = "#0D6EFD";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 2px 4px rgba(0, 0, 0, 0.08)";
                        e.currentTarget.style.borderColor = "#DBE0E6";
                      }}
                    >
                      <Typography
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#252D38",
                          flex: 1,
                        }}
                      >
                        Key Updates on MAS Policy Changes for FY {getMasFiscalYear(selectedPolicy)}
                      </Typography>
                      <OpenInNewIcon
                        sx={{
                          color: "#2E3742",
                          fontSize: "22px",
                          marginLeft: "12px",
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                
                {/* Nestle Key Notes Instructions */}
                {NESTLE_ENTITY_ID_LIST.includes(
                  parseInt(getUserDetails(PM_ENTITY_ID))
                ) && (
                  <NestleKeyNotesInstructions
                    isMobileView={isMobileView}
                    showPopup={showNestleKeyNotesPopup}
                    collapsed={nestleKeyNotesCollapsed}
                    onGotIt={handleNestleKeyNotesGotIt}
                    onCollapsedCardClick={handleNestleKeyNotesCollapsedCardClick}
                  />
                )}
                
                {/* Adobe Key Notes Instructions */}
               {isAdobeEntity && (
                  <AdobeKeyNotesInstructions
                    isMobileView={isMobileView}
                    showPopup={showAdobeKeyNotesPopup}
                    collapsed={adobeKeyNotesCollapsed}
                    onGotIt={handleAdobeKeyNotesGotIt}
                    onCollapsedCardClick={handleAdobeKeyNotesCollapsedCardClick}
                  />
                )}
                
                {claim &&
                  claim.length > 0 &&
                  claim.some(
                    (claimItem) =>
                      claimItem.remarks?.toLowerCase() ===
                      "information required"
                  ) && (
                    <>
                      <Typography
                        style={{
                          fontWeight: "600",
                          fontSize: "18px",
                          marginTop: "20px",
                          marginBottom: "15px",
                          textAlign: "left",
                          color: "#252D38",
                        }}
                        variant="h1"
                        tabIndex="0"
                      >
                        Action Required on Claims
                      </Typography>

                      <div className="pd-rt-0 pd-xs-0">
                        <Paper
                          sx={{
                            width: "100%",
                            overflow: "hidden",
                            borderRadius: "15px",
                          }}
                        >
                          <TableContainer
                            sx={{
                              maxHeight: 480,
                              border: "1px solid #DBE0E6",
                              borderRadius: "15px",
                            }}
                          >
                            <Table
                              responsive="md"
                              stickyHeader
                              aria-label="active claims table"
                            >
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      backgroundColor: "#F5F7F8",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        color: "#252D38",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Claim ID.
                                      <Tooltip
                                        title="Tap on Claim ID to View Details"
                                        placement="top"
                                        arrow
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: "#2E3742",
                                              color: "#FFFFFF",
                                              fontSize: "14px",
                                              fontWeight: "400",
                                              padding: "12px 16px",
                                              borderRadius: "8px",
                                              boxShadow:
                                                "0 0 10px 0 rgba(0, 0, 0, 0.02)",
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: "#2E3742",
                                            },
                                          },
                                        }}
                                      >
                                        <InfoOutlined
                                          style={{
                                            fontSize: "16px",
                                            color: "#47566A",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Tooltip>
                                    </div>
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      backgroundColor: "#F5F7F8",
                                      color: "#252D38",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Patient Name
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      backgroundColor: "#F5F7F8",
                                      color: "#252D38",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Status
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      backgroundColor: "#F5F7F8",
                                      color: "#252D38",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Claimed
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      backgroundColor: "#F5F7F8",
                                      color: "#252D38",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Approved
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      backgroundColor: "#F5F7F8",
                                      color: "#252D38",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Created On
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {claim
                                  .filter(
                                    (claimItem) =>
                                      claimItem.remarks?.toLowerCase() ===
                                      "information required"
                                  )
                                  .map((row) => (
                                    <TableRow
                                      key={row.claimid}
                                      hover
                                      tabIndex={-1}
                                    >
                                      <TableCell scope="row">
                                        <Link
                                          to={`/reimbursements/claimdetails/${row.claimid}`}
                                          className="claim-id-link"
                                          style={{
                                            color: "#004FB6",
                                            textDecoration: "underline",
                                            textDecorationStyle: "solid",
                                            fontWeight: "400",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {row.claimid}
                                        </Link>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "14px",
                                          color: "#47566A",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {row.name}
                                      </TableCell>
                                      <TableCell>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              color: "#47566A",
                                              textTransform: "capitalize",
                                              fontWeight: "400",
                                            }}
                                          >
                                            {row.remarks ===
                                            "information required"
                                              ? "Information Required"
                                              : row.remarks}
                                          </span>
                                          {row.remarks?.toLowerCase() ===
                                          "information required" ? (
                                            <Link
                                              to={`/reimbursements/informationneeded/${row.claimid}`}
                                              style={{
                                                color: "#AE0006",
                                                textDecoration: "none",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              Re-Submit
                                              <ArrowForwardIosIcon fontSize="18px" />
                                            </Link>
                                          ) : null}
                                        </div>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "14px",
                                          color: "#47566A",
                                          fontWeight: "400",
                                        }}
                                      >
                                        ₹{Number(row.claimamount).toFixed(2)}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "14px",
                                          color: "#47566A",
                                          fontWeight: "400",
                                        }}
                                      >
                                        ₹
                                        {Number(
                                          row.approvedclaimamount
                                        ).toFixed(2)}
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          fontSize: "14px",
                                          color: "#47566A",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {row.createddate
                                          ? new Date(
                                              row.createddate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            }) +
                                            " | " +
                                            new Date(
                                              row.createddate
                                            ).toLocaleTimeString("en-US", {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              hour12: true,
                                            })
                                          : "N/A"}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                        <br></br>
                        <br></br>
                      </div>
                    </>
                  )}

                {!isSubeno && (
                <>
                <Typography
                  style={{
                    fontWeight: "600",
                    fontSize: "18px",
                    marginTop: "10px",
                    marginBottom: "15px",
                    textAlign: "left",
                  }}
                  variant="h2"
                  tabIndex="0"
                >
                  {summary}
                </Typography>
                <Row
                  style={{ marginBottom: "12px" }}
                  tabIndex={"0"}
                  aria-label="Amounts"
                >
                  {ledger.amounts ? (
                    ledger.amounts
                      .sort((a, b) => a.id - b.id)
                      .map((amount) => {
                        const value = Number(
                          amount.utilisation || amount.value || 0
                        ).toFixed(2);
                        if (amount) {
                          return (
                            <Col
                              key={amount.id}
                              xs={12}
                              sm={12}
                              lg={4}
                              className="pd-xs-bt-15"
                            >
                              <div className="claimBottom">
                                <div>
                                  {/* <img src={limit} alt='' />&nbsp; &nbsp; */}
                                </div>
                                <div tabIndex={"0"}>
                                  <span
                                    style={{
                                      color: "#47566A",
                                      fontSize: "16px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {amount.type}
                                  </span>{" "}
                                  <br></br>
                                  <span
                                    style={{
                                      color: "#252D38",
                                      fontSize: "18px",
                                      fontWeight: "600",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    &#8377;{value ? value : "Not Available"}
                                  </span>
                                </div>
                              </div>
                            </Col>
                          );
                        }
                        return null;
                      })
                      .filter(Boolean)
                  ) : (
                    <>
                      <Col xs={12} sm={12} lg={4} className="pd-xs-bt-15">
                        <div className="claimBottom">
                          <div>
                            {/* <img src={limit} alt='' />&nbsp; &nbsp; */}
                          </div>
                          <div tabIndex={"0"}>
                            <span
                              style={{
                                color: "#47566A",
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                            >
                              Eligible Limit
                            </span>{" "}
                            <br></br>
                            <span
                              style={{
                                color: "#252D38",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              &#8377;{ledger.totallimit}
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} lg={4} className="pd-xs-bt-15">
                        <div className="claimBottom">
                          <div>
                            {/* <img src={inProgress} alt='' />&nbsp; &nbsp; */}
                          </div>
                          <div tabIndex={"0"}>
                            <span
                              style={{
                                color: "#47566A",
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                            >
                              Reimbursed/In Process
                            </span>{" "}
                            <br></br>
                            <span
                              style={{
                                color: "#252D38",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              &#8377;{ledger.totalapproved}
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} lg={4} className="pd-xs-bt-15">
                        <div className="claimBottom">
                          <div>
                            {/* <img src={inProgress} alt='' />&nbsp; &nbsp; */}
                          </div>
                          <div tabIndex={"0"}>
                            <span
                              style={{
                                color: "#47566A",
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                            >
                              Cashless Availed
                            </span>{" "}
                            <br></br>
                            <span
                              style={{
                                color: "#252D38",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              &#8377;{ledger.gocashless}
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} lg={4} className="pd-xs-bt-15">
                        <div className="claimBottom">
                          <div>
                            {/* <img src={balance} alt='' />&nbsp; &nbsp; */}
                          </div>
                          <div tabIndex={"0"}>
                            <span
                              style={{
                                color: "#47566A",
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                            >
                              Net Balance
                            </span>{" "}
                            <br></br>
                            <span
                              style={{
                                color: "#252D38",
                                fontSize: "18px",
                                fontWeight: "600",
                              }}
                            >
                              &#8377;{ledger.currentlimit}
                            </span>
                          </div>
                        </div>
                      </Col>
                    </>
                  )}
                </Row>
                <Typography
                  style={{
                    fontWeight: "500",
                    fontSize: "18px",
                    marginBottom: "15px",
                    color: "#252D38",
                    textAlign: "left",
                  }}
                  variant="h3"
                  tabIndex="0"
                  className="category-heading-display"
                >
                  Category Wise Benefits
                </Typography>
                <div
                  tabIndex={"0"}
                  className="table-container"
                  aria-label="Eligible Limits for various claims"
                >
                  <Table
                    className="table table-borderless reimburse-table"
                    stickyHeader
                    overflowX="auto"
                    sx={{
                      width: "100%",
                      minWidth: 0,
                      tableLayout: "fixed",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className="font-bold"
                          tabIndex="0"
                          style={{
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#252D38",
                          }}
                          sx={{ width: columnWidths[0] }}
                        >
                          Category
                        </TableCell>
                        <TableCell
                          className="font-bold"
                          tabIndex="0"
                          style={{
                            fontWeight: "500",
                            fontSize: "16px",
                            color: "#252D38",
                          }}
                          sx={{ width: columnWidths[1] }}
                        >
                          Eligible Limit
                        </TableCell>
                        {showBalances && (
                          <TableCell
                            className="font-bold"
                            tabIndex="0"
                            style={{
                              fontWeight: "500",
                              fontSize: "16px",
                              color: "#252D38",
                            }}
                            sx={{ width: columnWidths[2] }}
                          >
                            Available Limit
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reimbursementLimits.limits.map((row, index) => (
                        <TableRow
                          key={row.category}
                          style={{ backgroundColor: ledgerBg[row.group % 2] }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            tabIndex="0"
                            style={{
                              fontWeight: "400",
                              fontSize: "14px",
                              color: "#252D38",
                            }}
                            sx={{ width: columnWidths[0] }}
                          >
                            {" "}
                            {getFormName(row.category)}{" "}
                          </TableCell>
                          <TableCell
                            tabIndex="0"
                            style={{
                              fontWeight: "400",
                              fontSize: "14px",
                              color: "#252D38",
                            }}
                            sx={{ width: columnWidths[1] }}
                          >
                            &#8377;{row.limit}
                          </TableCell>
                          {showBalances && (
                            <TableCell
                              tabIndex="0"
                              style={{
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "#252D38",
                              }}
                              sx={{ width: columnWidths[2] }}
                            >
                              &#8377;
                              {row.balance !== undefined
                                ? row.balance
                                : row.limit}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
                </>
                )}
                <br></br>
                <br></br>
                <div className="queries-new-right">
                  <div className="queries-header">
                    <b>Need help with Claim?</b>
                  </div>
                  <div className="queries-content">
                    <p>
                      If you have any questions or concerns about your OPD
                      claims, just drop us an email at{" "}
                      <strong>{getCustomerSupportEmailId()}</strong>. Our
                      support team will get back to you as soon as possible to
                      help you out.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            {loading ? (
              <CircularProgress color="inherit" />
            ) : (
              <div
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "1rem",
                  background: "white",
                  borderRadius: "10px",
                  margin: "0 auto",
                  color: "black",
                  padding: "2rem",
                  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
                  maxWidth: 420,
                }}
              >
                <p
                  style={{
                    display: "inline",
                    alignItems: "center",
                    textAlign: "center",
                    margin: "0",
                  }}
                >
                  <strong>{message}</strong>
                </p>
                <Button
                  id="create-claim-btn"
                  variant="primary"
                  style={{
                    border: "blue",
                    cursor: "pointer",
                    text: "white",
                  }}
                  className={"border-radius-10"}
                  onClick={() => (window.location.href = RELOGIN_URL)}
                >
                  Login
                </Button>
              </div>
            )}
          </Backdrop>
        )}
      </Row>
      {!loading && (
        <div
          className="mobile-page-with-footer"
          style={{ marginTop: "0px", paddingTop: "0px", paddingBottom: "120px" }}
        >
          <MobileSecurityFooter />
        </div>
      )}
    </>
  );
}
